import React from 'react'
import { useStudentHomeroomInfo } from '@mth/hooks/useStudentHomeroomInfo/useStudentHomeroomInfo'

interface TeacherNameProps {
  studentId: number
  schoolYearId: number
}

export const TeacherName: React.FC<TeacherNameProps> = ({ studentId, schoolYearId }) => {
  const { teacherName } = useStudentHomeroomInfo(studentId, schoolYearId)

  return teacherName ? <>({teacherName})</> : null
}
